<template>
  <rv-dialog
    ref="dialogRef"
    class="license-expiring-dialog"
    data-automation="license-expiring-dialog"
    persistent
    width="426px"
    v-on="$attrs"
  >
    <template #title>
      <div class="row no-wrap items-center justify-center full-width text-subtitle1 q-px-md">
        <q-icon
          class="q-mr-sm"
          color="grey-2"
          name="mdi-alert-circle"
          size="32px"
        />
        <div>
          {{ isLicenseActive ? $t('license.dialog.expiring.title') : $t('license.dialog.expired.title') }}
        </div>
      </div>
    </template>

    <template #default>
      <div class="row no-wrap justify-center">
        <div
          v-for="(number) in dayNumbers"
          :key="number"
          class="number-block rounded-borders bg-grey-5 text-large q-mr-sm q-pa-md"
        >
          {{ number }}
        </div>
      </div>

      <q-card-section>
        <i18n-t
          v-if="isLicenseActive"
          :keypath="'license.dialog.expiring.description'"
          tag="div"
        >
          <template #date>
            <strong>
              {{ expiresAtFormatted }}
            </strong>
          </template>
        </i18n-t>
        <i18n-t
          keypath="license.dialog.text"
          tag="div"
        >
          <template #email>
            <a :href="`mailto:${$t('license.dialog.email')}`">
              {{ $t('license.dialog.email') }}
            </a>
          </template>
        </i18n-t>
      </q-card-section>
    </template>

    <template #actions>
      <q-card-section class="full-width row justify-end q-px-md q-py-none">
        <rv-button
          data-automation="license-expired-dialog__close"
          :label="$t('license.dialog.buttonText')"
          @click="onClose"
        />
      </q-card-section>
    </template>
  </rv-dialog>
</template>

<script lang="ts" setup>
import { useDialogPluginComponent } from 'quasar'
import { computed } from 'vue'
import { useLicensing } from '~stores/composables/useLicensing'


const {
  dialogRef,
  onDialogHide,
} = useDialogPluginComponent()

const {
  expirationDuration,
  expirationInterval,
  expiresAtFormatted,
  isLicenseActive,
  setLicenseNotificationShown,
} = useLicensing()

const dayNumbers = computed(() => {
  let days
  if (!expirationInterval.value || expirationInterval.value <= 0) {
    days = 0
  } else {
    days = expirationDuration.value?.days || 1
  }
  return String(days).padStart(2, '0')
})

function onClose (): void {
  setLicenseNotificationShown(true)
  onDialogHide()
}


</script>

<style lang="sass" scoped>
.number-block
  text-align: center
  width: 1.8em
</style>
